import React from "react";
import { ProgressBar } from "@shopify/polaris";
import styles from "./UploadGridItem.module.css";

interface MyProps {
    selectedStyle: string;
    uploadProgress: number;
}

const UploadingImage = (props: MyProps) => (
    <div className={props.selectedStyle}>
        <div className={styles.container}>
            <div className={styles.UploadStateText}>
                <b> Uploading Image </b>
            </div>
            <ProgressBar progress={props.uploadProgress} size={"small"} />
        </div>
    </div>
);
export default UploadingImage;
